const localeValue = '' + $('#locale').attr('value')
const stripePublicKey = '' + $('#stripePublicKey').attr('value')
const stripe = Stripe(stripePublicKey + '', { locale: localeValue })
let elements
let cardNumber
let cardExpiry
let cardCvc

const style = {
  base: {
    fontSize: '14px',
    color: '#333333',
    fontFamily: 'Arial, sans-serif',
    fontSmoothing: 'antialiased',
    '::placeholder': {
      color: '#dddddd'
    },
    iconColor: '#333333'
  }
}

const styleDarkmode = {
  base: {
    fontSize: '14px',
    color: '#bbbbbb',
    backgroundColor: '#333333',
    fontFamily: 'Arial, sans-serif',
    fontSmoothing: 'antialiased',
    '::placeholder': {
      color: '#444444'
    },
    iconColor: '#bbbbbb'
  }
}

window.addEventListener('DOMContentLoaded', function() {
  getForm().submit(handleSubmit)
  initialize()
})

async function initialize() {
  const darkmode = $('html').hasClass('darkmode')
  const options = {
    currency: 'eur'
  }
  elements = stripe.elements(options)

  cardNumber = elements.create('cardNumber', {
    style: darkmode ? styleDarkmode : style,
    showIcon: true,
    placeholder: '1234 1234 1234 1234'
  })
  cardNumber.mount('#card-number')

  cardNumber.on('change', function(event) {
    handleCardInputChange('zahlungsartCardNumberErrors', event)
  })

  cardExpiry = elements.create('cardExpiry', {
    style: darkmode ? styleDarkmode : style,
    placeholder: 'MM/JJ'
  })
  cardExpiry.mount('#card-expiry')

  cardExpiry.on('change', function(event) {
    handleCardInputChange('zahlungsartCardExpiryErrors', event)
  })

  cardCvc = elements.create('cardCvc', {
    style: darkmode ? styleDarkmode : style,
    placeholder: 'CVC'
  })
  cardCvc.mount('#card-cvc')
  cardCvc.on('change', function(event) {
    handleCardInputChange('zahlungsartCardCvcErrors', event)
  })
}

async function handleSubmit(e) {
  const zahlungsartValue = $('input[name="zahlungsartAuswahlForm.zahlungsart"]:checked').val()
  if (zahlungsartValue === 'kreditkarte') {
    e.preventDefault()
    hideFormErrors()
    setLoading(true)
    const resultSetupIntent = await createSetupIntent()
    console.log(resultSetupIntent)
    console.log(resultSetupIntent.data.stripeZahlungsartAuswahlCreateSetupIntent.clientSecret)

    if (resultSetupIntent.errors) {
      showFormErrors(resultSetupIntent.errors)
      setLoading(false)
      return
    }

    stripe.confirmCardSetup(
      resultSetupIntent.data.stripeZahlungsartAuswahlCreateSetupIntent.clientSecret, {
        payment_method: {
          card: cardNumber
        }
      }
    ).then(resultConfirmSetup => {
        if (resultConfirmSetup.setupIntent) {
          let paymentMethodId = resultConfirmSetup.setupIntent.payment_method
          $('#zahlungsartAuswahlForm\\.zahlungsartKreditkarteForm\\.stripePaymentMethodId').val(paymentMethodId)
          getForm().unbind('submit', handleSubmit)
          getForm().submit()
        }
        if (resultConfirmSetup.error) {
          showFormError(resultConfirmSetup.error.message)
          setLoading(false)
        }

      }
    ).catch(err => sendStripeApiError('confirmCardSetup', err))
  }
}

async function createSetupIntent() {
  const stripeCustomerId = $('#zahlungsartAuswahlForm\\.zahlungsartKreditkarteForm\\.stripeCustomerId').attr('value')
  const query = `mutation stripeZahlungsartAuswahlCreateSetupIntent($stripeCustomerId: String) { stripeZahlungsartAuswahlCreateSetupIntent(stripeCustomerId: $stripeCustomerId){clientSecret}}`
  const body = JSON.stringify({
    query,
    variables: {
      stripeCustomerId: stripeCustomerId
    }
  })
  const response = await fetch(
    '/graphql',
    {
      method: 'post',
      body: body,
      headers: {
        'Content-Type': 'application/json',
        'Content-Length': body.length
      }
    }
  )

  if (response.ok) {
    return await response.json()
  }
}

function showFormErrors(errorMessages) {
  for (let i = 0; i < errorMessages.length; i++) {
    $('#formErrors .message').html('<p>' + errorMessages[i].message + '</p>')
  }
  $('#formErrors').show()
}

function showFormError(errorMessage) {
  $('#zahlungsartErrors .message').html(errorMessage)
  $('#zahlungsartErrors').show()
}

function hideFormErrors() {
  $('#zahlungsartErrors .message').html('')
  $('#zahlungsartErrors').hide()
}

function handleCardInputChange(messageBoxId, event) {
  if (event.error) {
    $('#' + messageBoxId + ' .message').html(event.error.message)
    $('#' + messageBoxId).show()
  } else {
    $('#' + messageBoxId + ' .message').html('')
    $('#' + messageBoxId).hide()
  }
}

function setLoading(isLoading) {
  if (isLoading) {
    getSubmit().prop('disabled', true)
  } else {
    getSubmit().prop('disabled', false)
  }
}

function getForm() {
  return $('#profipaketZahlungartAuswahl').parents('form:first')
}

function getSubmit() {
  return getForm().children(' button[type="submit"]')
}

async function sendStripeApiError(apiMethod, error) {
  const query = `mutation stripeLogApiError($apiMethod: String!, $error: String!) { stripeLogApiError(apiMethod: $apiMethod, error: $error)}`
  const body = JSON.stringify({
    query,
    variables: {
      apiMethod: apiMethod,
      error: error + ''
    }
  })

  const response = await fetch(
    '/graphql',
    {
      method: 'post',
      body: body,
      headers: {
        'Content-Type': 'application/json',
        'Content-Length': body.length
      }
    }
  )
  return await response.json()
}

